import useNotificationAction from 'containers/Chats/hooks/useNotificationAction'
import SendPhotoPopup from 'containers/Chats/Notifications/SendPhotoPopup'
import { selectChatNotifications } from 'containers/Chats/chatSlice'
import BasicPopup from 'containers/Chats/Notifications/BasicPopup'
import useTranslation from 'hooks/useTranslation'
import usePopupState from 'hooks/usePopupState'
import { useHistory } from 'react-router-dom'
import { useSelector } from 'react-redux'
import Option from 'components/Option'
import React from 'react'

const NotificationSummary: React.FC = () => {
  const notifications = useSelector(selectChatNotifications)
  const { popup } = usePopupState<chat.NotificationPopup | undefined>()

  const { performAction } = useNotificationAction()
  const { t } = useTranslation('chat')
  const { push } = useHistory()

  const importantNotifications = notifications.filter(n => n.isImportant)
  const unreadNotifications = notifications.filter(n => !n.read_date)

  return (
    <div className='account__status'>
      {popup?.type === 'notificationModal' && <BasicPopup
        {...popup.props}
      />}
      {popup?.type === 'sendPhoto' && <SendPhotoPopup
        {...popup.props}
      />}
      {importantNotifications.length > 1
        ? <Option
          selected
          icon='warning'
          buttonText={t('look')}
          title={`${importantNotifications.length} ${t('importantMessagesAreWaitingForYou')}`}
          desc={t('checkNow')}
          action={() => {
            push('/chat')
          }}
        />
        : importantNotifications.length === 1 ? <Option
          selected
          icon='warning'
          buttonText={t('goTo')}
          title={importantNotifications[0].title}
          desc={importantNotifications[0].description}
          action={() => {
            const { id, action, read_date } = importantNotifications[0]
            performAction(id, action, read_date)
          }}
        />
          : unreadNotifications.length > 0 ? <Option
            selected
            icon='mail'
            buttonText={t('look')}
            title={unreadNotifications.length === 1
              ? t('youHaveAnUnreadMessage')
              : unreadNotifications.length < 5
                ? `${t('youHave')} ${unreadNotifications.length} ${t('unreadMessages<5')}`
                : `${t('youHave')} ${unreadNotifications.length} ${t('unreadMessages>=5')}`
            }
            desc={t('goToMessages')}
            action={() => {
              push('/chat')
            }}
          />
            : <Option
              selected
              secondary
              icon='check'
              title={t('everythingsAllRight')}
              desc={t('youAreUpToDate')}
            />}
    </div>
  )
}

export default NotificationSummary